import { useQuery } from "react-query";
import TrainingPlansApiClient from "api/TrainingPlansApiClient.js";

export function useSchoolTrainingPlans(schoolId, payload, options) {
    return useQuery(
        ["trainingPlans", "school", Number(schoolId), payload],
        () => TrainingPlansApiClient.getSchoolTrainingPlans(schoolId, payload),
        options,
    );
}
